import script from "./outletClaim.vue?vue&type=script&setup=true&lang=js"
export * from "./outletClaim.vue?vue&type=script&setup=true&lang=js"

import "./outletClaim.vue?vue&type=style&index=0&id=588763ef&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-588763ef"]])

export default __exports__